import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Heart } from 'lucide-react';

const ItemCard = ({ item, onClick }) => {
    const { t } = useLanguage();
    const navigate = useNavigate();

    const handleClick = () => {
        if (onClick) {
            onClick(item);
        } else {
            navigate(`/gallery/${item.id}`);
        }
    };

    const getStatusBadge = () => {
        if (item.status === 'sold') {
            return (
                <span className="absolute top-2 right-2 px-2 py-1 text-xs font-mono uppercase bg-white/90 text-muted-foreground">
                    {t('sold')}
                </span>
            );
        }
        if (item.status === 'unsold') {
            return (
                <span className="absolute top-2 right-2 px-2 py-1 text-xs font-mono uppercase bg-white/90 text-muted-foreground">
                    Unsold
                </span>
            );
        }
        return null;
    };

    const mainPhoto = item.photo_processed || item.photos_original?.[0];

    return (
        <div
            className="card-gallery group cursor-pointer gallery-item"
            onClick={handleClick}
            data-testid={`item-card-${item.id}`}
        >
            <div className="relative w-full h-full">
                <img
                    src={mainPhoto}
                    alt={item.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                />
                
                {/* Gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-foreground/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                
                {/* Status badges */}
                {getStatusBadge()}

                {/* Bottom info */}
                <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
                    <h3 className="text-white font-heading text-sm font-medium truncate mb-1">
                        {item.title}
                    </h3>
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                            {item.yess_count > 0 && (
                                <span className="flex items-center gap-1 text-white/80 text-xs">
                                    <Heart className={`w-3 h-3 ${item.user_reaction === 'yess' ? 'fill-[#F8BBD6] text-[#F8BBD6]' : ''}`} />
                                    {item.yess_count}
                                </span>
                            )}
                            {item.size_text && (
                                <span className="text-white/80 text-xs font-mono uppercase">
                                    {item.size_text}
                                </span>
                            )}
                        </div>
                        <span className="text-white font-mono text-sm">
                            €{item.price?.toFixed(0)}
                        </span>
                    </div>
                </div>
            </div>

            {/* Mobile-visible info (always shown on small screens) */}
            <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-foreground/70 to-transparent md:hidden">
                <h3 className="text-white font-heading text-sm font-medium truncate">
                    {item.title}
                </h3>
                <div className="flex items-center justify-between mt-1">
                    <span className="text-white/80 text-xs font-mono uppercase">
                        {item.size_text || t(item.category)}
                    </span>
                    <span className="text-white font-mono text-sm">
                        €{item.price?.toFixed(0)}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default ItemCard;
